const eventName = 'northguard:support-ticket-mutation';
const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;

// DOM events keep observers connected even when shared helpers are in separate bundles.
export function observeSupportTicketMutation(mutationId, observer, target = document) {
    if (!uuidPattern.test(mutationId)) throw new TypeError('Invalid support ticket mutation ID.');
    const listener = (event) => {
        const {phase, mutation, result, tasks} = event.detail;
        if (mutation.mutation_id !== mutationId || !Object.hasOwn(observer, phase)) return;
        tasks.push(Promise.resolve().then(() => observer[phase](mutation, result)));
    };
    target.addEventListener(eventName, listener);
    return () => target.removeEventListener(eventName, listener);
}

export async function notifySupportTicketMutation(phase, mutation, result, target = document) {
    const tasks = [];
    target.dispatchEvent(new CustomEvent(eventName, {detail: {phase, mutation, result, tasks}}));
    await Promise.all(tasks);
}
